// Keep critical routes synchronous, to avoid chunk loading errors
import NotFound from 'src/views/Miscellaneous/Error/404.vue'

const routes = [
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: NotFound,
    meta: { isPublic: true }
  }
]

export default routes
